import React, { useState, useEffect } from 'react';
import { getPossessionStages } from '../services/api';

const PossessionTimeline = () => {
  const [possessionStages, setPossessionStages] = useState([]);

  useEffect(() => {
    getPossessionStages().then(data => setPossessionStages(data || []));
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">POSSESSION</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">
            Move in, Whenever You're Ready!
          </h2>
          <p className="text-gray-500 mt-3">Discover the key advantages of investing with us</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {possessionStages.map((stage, idx) => (
            <div
              key={idx}
              className="bg-gray-50 rounded-2xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer group border border-gray-100 hover:border-red-200"
            >
              <div className={`w-16 h-16 ${stage.color} rounded-2xl mx-auto mb-4 flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <div className="w-6 h-6 bg-white/30 rounded-full"></div>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">{stage.stage}</h3>
              <p className="text-2xl font-bold text-red-500">{stage.count}</p>
              <p className="text-xs text-gray-500 mt-1">Properties | {stage.timeline}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PossessionTimeline;
